<template>
  <div class="is-center section">
    <h1 class="title is-2">{{ mainTitle }}</h1>
    <h2 class="subtitle is-5">
      <VueTyper :text="subtitle"></VueTyper>      

    </h2>
  </div>
</template>

<script>
import { VueTyper } from 'vue-typer'

export default {
  components : {
    VueTyper
  },
  props : [ 'mainTitle' , 'subtitle'],
  name: 'Header'
}
</script>

<style lang="scss">
@import '../../static/_variables.scss';

.subtitle{
  margin-top: 1em !important;
}
.vue-typer {
  .custom.char{
    color: #ffffff !important;

     &.selected {
      background-color: $stipe-color;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/componests/Header.vue